// ImageWithDeleteButton.jsx
import React from "react";

import CloseIcon from "@mui/icons-material/Close"; // Assuming you're using Material-UI for icons

const ImageWithDeleteButton = ({ logoName, watch, setValue }) => {
  const handleDeleteImage = () => {
    setValue(logoName, null); // Clear the image field
  };


  return (
    <>
      {watch(logoName) && (
        <>
          <div style={{position:"relative"}}>
            <img
              src={watch(logoName)}
              alt=""
              width={120}
              height={80}
               style={{objectFit:"cover"}} 
              className="rounded border"
            />
            <CloseIcon
              style={{
                fontSize: "14px",
                marginBottom: "10px",
                borderRadius: "10px",
                background: "red",
                color: "white",
                cursor: "pointer",
                position:"absolute",
                right:".5px",
                top:"-2px"
              }}
              onClick={handleDeleteImage}
            />
          </div>
        </>
      )}
    </>
  );
};

export default ImageWithDeleteButton;
